import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface FaqDetialRequest {
    category: string;
    list_no: string;
}

export interface FaqDetailResponse {
    // statusCode: number;
    // message: string;
    // data: {
    flag: boolean;
    list_no: number;
    notice: number;
    subject: string;
    contents: string;
    w_date: string;
    b_file: string;
    // };
}

export const useGetConsoleFaqDetail = ({ category, list_no }: FaqDetialRequest): UseQueryResult<FaqDetailResponse, Error> => {
    let url = enum_api_uri.get_console_faq_detail.replace(":category", category).replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleFaqDetail", category, list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
        enabled: !!category && !!list_no,
    });
};
